import { useCallback } from 'react'

import { useMetricName } from 'utils/hooks/metrics/useMetricName'
import { IndexMetric } from 'utils/types/metricsV2'
import { useMetricsSandbox } from 'containers/Metrics/SelectedMetrics/useMetricsSandbox'

export const useMetricOption = (metric: IndexMetric) => {
  const { metricName } = useMetricName(metric)
  const {
    isMetricInSandbox,
    toggleMetricInSandbox,
    isAddMetricToSandboxDisabled,
  } = useMetricsSandbox()

  const onClick = useCallback(() => {
    if (isAddMetricToSandboxDisabled() && !isMetricInSandbox(metric)) return

    toggleMetricInSandbox(metric)
  }, [
    metric,
    isAddMetricToSandboxDisabled,
    isMetricInSandbox,
    toggleMetricInSandbox,
  ])

  return {
    metricName,
    checked: isMetricInSandbox(metric),
    onClick,
  }
}
